export default "__VITE_ASSET__DwRgDGO___"